/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import { toJS } from 'mobx';
import Button from '@material-ui/core/Button';

import type UserStore from 'stores/UserStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../ActionsList.module.scss';

export type ActionButtonProps = {
  action: Object,
  data: any,
  to?: $PropertyType<LinkProps, 'to'>,
  onActionDrawer: (action: string, data: any) => void,
  onActionDownload: () => void,
  disabled?: boolean,
};

type InjectedProps = {
  userStore: UserStore,
} & TranslatorProps;

@translate()
@inject('userStore')
@observer
class ActionButton extends ComponentWithInjectedProps<ActionButtonProps, {}, InjectedProps> {
  static defaultProps = {
    disabled: false,
  };

  render() {
    const {
      userStore: { activeUser, isReadOnly },
      action,
      data,
      disabled,
      t,
    } = this.props;

    const _disabled = disabled || isReadOnly;

    return {
      drawer: action.action && (
        <Button
          disabled={disabled}
          color="default"
          variant="outlined"
          onClick={() => this.props.onActionDrawer(action.action, data)}
          className={disabled ? styles.disabled : styles.enabled}
        >
          <svg className="button-icon">
            <use xlinkHref={action.icon} />
          </svg>
          {t(action.label)}
        </Button>
      ),
      link: (action.to || this.props.to) && (
        <Link
          className={disabled ? styles['disabled-link'] : ''}
          to={
            this.props.to
              ? this.props.to
              : {
                  pathname: action.to.pathname,
                  state: action.to.setStateData ? toJS(data) : null,
                }
          }
        >
          <Button
            disabled={disabled}
            color="default"
            variant="outlined"
            className={disabled ? styles.disabled : styles.enabled}
          >
            <svg className="button-icon">
              <use xlinkHref={action.icon} />
            </svg>
            {t(action.label)}
          </Button>
        </Link>
      ),
      download: action.type === 'download' && (
        <Button
          disabled={disabled}
          color="default"
          variant="outlined"
          onClick={() => this.props.onActionDownload()}
          className={disabled ? styles.disabled : styles.enabled}
        >
          <svg className="button-icon">
            <use xlinkHref={action.icon} />
          </svg>
          {t(action.label)}
        </Button>
      ),
    }[action.type ? action.type : 'drawer'];
  }
}

export default ActionButton;
